import React from 'react';
import { Image, ImageProps } from '@chakra-ui/react';

interface LogoProps extends Omit<ImageProps, 'src' | 'alt'> {
  variant?: 'default' | 'white' | 'brandMark';
  size?: 'sm' | 'md' | 'lg' | 'xl' | 'xxl';
}

const Logo: React.FC<LogoProps> = ({ 
  variant = 'default', 
  size = 'md',
  ...props 
}) => {
  const sizeMap = {
    sm: '30px',
    md: '50px', 
    lg: '80px',
    xl: '120px',
    xxl: '300px',
  };

  const getSrc = () => {
    switch (variant) {
      case 'brandMark':
        return '/assets/logo/PNG/Brand_Mark_RGB.png';
      case 'white':
        return '/assets/logo/PNG/Logo_RGB.png';
      default:
        return '/assets/logo/PNG/Logo_RGB.png';
    }
  };

  const getFilter = () => {
    if (variant === 'white') {
      return 'brightness(0) invert(1)';
    }
    return undefined;
  };

  return (
    <Image
      src={getSrc()}
      alt="ReDeuce Logo"
      h={sizeMap[size]}
      w="auto"
      filter={getFilter()}
      {...props}
    />
  );
};

export default Logo; 